import { useEffect, useState } from "react";
import { Grid, Paper } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import {
  ContentHeaderTabs, CustomTabPanel, HeaderTab
} from "../../components/tabs/Tabs";
import { getCurrentProfile } from "../../actions/profile";
import { getCategories } from "../../actions/categories";
import Payments from "../../components/user/tabs/Payments";
import Documentos from "../../components/user/tabs/Documentos";
import MainInfo from "../../components/user/tabs/Main";

import { useDispatch } from "react-redux";

const Perfil = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  // Al volver del onboarding de Stripe (?connect=return|refresh) se abre la pestaña de pagos
  const [value, setValue] = useState(searchParams.get("connect") ? 2 : 0);

  useEffect(() => {
    dispatch(getCurrentProfile());
    dispatch(getCategories());
  }, []);

  return (
    <Grid className="main-page" container>
      <Grid size={12}>
        <Paper>
          <ContentHeaderTabs
            value={value}
            onChange={(_, newValue) => setValue(newValue)}
            aria-label="tabs perfil"
          >
            <HeaderTab label="Info del perfil" />
            <HeaderTab label="Documentos oficiales" />
            <HeaderTab label="Datos para pagos" />
          </ContentHeaderTabs>
        </Paper>
        <CustomTabPanel value={value} index={0} styles={{ p: 0, marginTop: 3 }}>

          {/* Componente donde esta la info(Email, tel, direcciones, redes) del usuario */}
          <MainInfo />

        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <Documentos />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <Payments />
        </CustomTabPanel>
      </Grid>
    </Grid>
  )
}

export default Perfil;